/**
 * @fileoverview Shared upload file extension groups used by CMS UI and API upload validation.
 */

export default {
  font: ['.otf', '.ttf'],
  image: ['.jpeg', '.jpg', '.png'],
  pdf: ['.pdf'],
  other: ['.csv', '.txt', '.js'],
  video: ['.avi', '.flv', '.mkv', '.mov', '.mp4', '.mpeg', '.mpg', '.ogv', '.ts', '.wmv', '.webm'],
  audio: ['.aac', '.flac', '.m4a', '.mp3', '.ogg', '.wav'],
};
